import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'loginName',
      type: 'input',
      label: '账号',
      placeholder: '请输入账号'
    },
    {
      field: 'nickName',
      type: 'input',
      label: '昵称',
      placeholder: '请输入昵称'
    }
  ]
}
